import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import makeStyles from '@material-ui/core/styles/makeStyles';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import GcpBox from '../gcp-box';
import GcpPublicWrapper from '../gcp-public-wrapper';
import GcpTypography from '../gcp-typography';

const useStyles = makeStyles(
  (theme) => ({
    divider: {
      top: 0,
      height: '4px',
      backgroundColor: theme.palette.common.ceriseRed,
    },
  }),
  { name: 'GcpPublicWrapper' }
);

interface GcpFallbackProps {
  title?: string;
  message?: string;
  btn: string;
  handleOnClick: () => void;
}

const GcpFallback: FC<GcpFallbackProps> = (props) => {
  const { title, message, btn, handleOnClick } = props;
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <GcpPublicWrapper>
      <Divider absolute className={classes.divider} />
      <GcpBox isFullWidth mt={4} textAlign="center">
        <GcpTypography variant="h1">
          {title || t('error.title.code')}
        </GcpTypography>
      </GcpBox>
      {message && (
        <GcpBox isFullWidth mt={3} textAlign="center">
          <GcpTypography paint="hitGray" variant="subtitle1">
            {message}
          </GcpTypography>
        </GcpBox>
      )}
      <GcpBox isFullWidth display="flex" justifyContent="center" mt={5}>
        <Button
          color="primary"
          size="large"
          variant="contained"
          onClick={handleOnClick}
        >
          {t(btn)}
        </Button>
      </GcpBox>
    </GcpPublicWrapper>
  );
};

export default GcpFallback;
